import { put, takeLatest, all } from "redux-saga/effects";
import { LOGIN } from "../constants/auth";
import { loginUserSuccess, loginUserError } from "../actions/auth";
import setAuthToken from "../../utils/setAuthToken";

import { loginApi } from "../../apiCalls/auth";

function* loginUser(action) {
  try {
    console.log("Trying to save here");
    const response = yield loginApi(action.payload);
    if (response.data.statusCode === 200) {
      console.log("Now saving auth data ", response.data.data);
      setAuthToken(response.data.data.updateAccessToken.accessToken);

      let result = response.data.data.updateAccessToken;
      //remove unnecessary variables from the response object
      delete result.resetPasswordRequestedAt;
      delete result.password;
      delete result.lastLogin;
      delete result.loginCount;
      delete result.registrationDate;

      result['PRODAInfo'] = response.data.data.prodaInfo['PRODAInfo'];
      result['PRODAUpdateStatus'] = response.data.data.prodaInfo['PRODAUpdateStatus'];
      result['certificatesExpiryInfo'] = response.data.data.certificateInfo;


      console.log("Saving this result: ", result);
      yield put(loginUserSuccess(result));
    } else if (
      response.data.statusCode === 400 ||
      response.data.statusCode === 401 ||
      response.data.statusCode === 403
    ) {
      yield put(loginUserError(response.data.message));
    } else if (response.status === 500) {
      yield put(
        loginUserError(
          "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        )
      );
    }
  } catch (error) {
    yield put(
      loginUserError(
        "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
      )
    );
    if (process.env.NODE_ENV !== "production") {
      //console.log(error);
    }
  }
}

export default function* authSaga() {
  yield all([takeLatest(LOGIN, loginUser)]);
}
